<template>
  <div style="padding-bottom: 20px">
    <a-table
      :scroll="{ x: 500 }"
      :columns="columns"
      :data-source="list"
      class="nopaddingEstimateTable"
      :pagination="false"
      row-key="id"
    >
      <template v-for="el in fixedArr" :slot="el" slot-scope="text">
        <span :key="el">{{ text ? Number(text).toFixed(2) : "-" }}</span>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  expectationEstimationColumns,
  expectationEstimationListCopy,
} from "../../../../EstimateConfig/estimateConfig";
import { getRequest } from "@/components/Common/Utils/Utils";
import { mapState } from 'vuex'
export default {
  props: ["isAdd", "resId", "tabKey", "details"],
  data() {
    return {
      property: "value",
      mode: 1,
      list: [],
      sectionList: [],
      expectationEstimationListCopy,
      estimateId: getRequest("id"),
      fixedArr: [],
      energySystemName: "",
      energySystem: "",
    };
  },

  computed: {
    ...mapState('estimate',['dataDictionary']),
    columns() {
      let newColumns = this.dealColumns();
      return newColumns;
    },
  },
  mounted() {
    this.init()
    this.setVal(this.details)
  },
  watch: {
    resId(val) {
      if (val) this.getDetails(val);
    },
    tabKey() {
      if (this.resId && this.list.length === 0 && this.energySystem) this.init(this.resId);
    },
    details: {
      handler(data) {
        this.setVal(data)
      },
      deep: true,
    },
  },
  methods: {
    setVal(data){
      let { prediction } = data;
      let { energySystem } = prediction || {};
      this.energySystem = energySystem;
      // this.getName();
      this.init(this.resId)
    },
    dealColumns() {
      let newColumns = [...expectationEstimationColumns];
      // let sectionLength = this.sectionList.length;、
      this.sectionList.forEach((el) => {
        newColumns.push({
          title: "预估值",
          dataIndex: `estimation${el.field}`,
          scopedSlots: { customRender: `estimation${el.field}` },
          width: 120,
        });
      });
      return newColumns;
    },

    init() {
      if (this.estimateId && this.isAdd) {
        this.getDetails(this.estimateId);
      } else if (!this.isAdd && this.resId) {
        this.getDetails(this.resId);
      }

      if(this.energySystem) this.getName();
    },
    getName() {
      let obj =
        this.dataDictionary.EnergySystem.find(
          (el) => el.dictKey === this.energySystem
        ) || {};
      if (obj.dictValue){
        this.energySystemName = obj.dictValue.replace("体系", "") || "";
      }  
    },
    getDetails(id) {
      if (!id) return;
      this.sectionList = [];
      this.list = [];
      this.$http
        .get(
          `/sat-maximization/opweightrangeformula/subDetail?predictionId=${id}`
        )
        .then((res) => {
          let { success, data } = res || {};
          if (success) {
            //动态生成头部区间
            let sectionList = []
            data.forEach((el) => {
              sectionList.push({
                name: `${el.initialBwforaa}-${el.finalBwforaa}kg`,
                field: `${el.initialBwforaa}-${el.finalBwforaa}`,
              });
              this.fixedArr.push(`estimation${el.initialBwforaa}-${el.finalBwforaa}`);
              this.fixedArr.push(`observation${el.initialBwforaa}-${el.finalBwforaa}`);
            });
            let list = []
            this.expectationEstimationListCopy.forEach((item) => {
              let obj = {
                name: item.name.indexOf("能量体系名称") >= 0 ? item.name.replace("【能量体系名称】",this.energySystemName) : item.name,
                unit: item.unit,
              };
              data.forEach((el) => {
                let dataBase = el.opWeightRangeFormula;
                obj[`estimation${el.initialBwforaa}-${el.finalBwforaa}`] = dataBase[item.field1];
                // obj[`observation${el.initialBwforaa}-${el.finalBwforaa}`] = dataBase[item.field2];
              });
              list.push(obj);
              
            });
            this.list = [...list]
            this.sectionList = [...sectionList]
          }
        });
    },
  },
};
</script>